<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.name === 'loan'"></router-view>
    </keep-alive>
    <router-view  v-if="$route.name !== 'loan'"></router-view>
  </div>
</template>

<script>
import store from '@/store'
export default {
  data() {
    return {};
  },
  methods: {},
  async created() {
    // await store.dispatch('fetchFlutterBaseInfo');
  },
};
</script>

<style lang="scss" scoped>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
